import { Typography, Paper } from '@mui/material'
import { useTranslation } from 'react-i18next'
import CheckRiskStatus from '../components/CheckRiskStatus'
import TimelineDotLine from '../components/TimelineDotLine'

const CheckComments = ({ commentsCheck }) => {
  const { t } = useTranslation(['common'])
  const comments = Array.isArray(commentsCheck) ? commentsCheck : []
  const hasChecks = comments.length > 0
  const checkLength = comments.length

  return (
    <>
      <Paper elevation={0} variant="colorPrimary" sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <Typography>{t('common:comments')}</Typography>
        <CheckRiskStatus checkLength={checkLength} hasChecks={hasChecks} label={t('common:comment')} />
      </Paper>
      {hasChecks &&
        comments.map((item, index) => (
          <TimelineDotLine key={index} color="#7e65d5">
            <Paper variant="rootOutlined" elevation={0} sx={{ flex: 1 }}>
              <div className="c-detail-col">
                <div className="c-detail-row">
                  <Typography variant="subtitle1">{t('common:user')}</Typography>
                  <Typography variant="subtitle3">{item.email}</Typography>
                </div>
                <div className="c-detail-row">
                  <Typography variant="subtitle1">{t('common:description')}</Typography>
                  <Typography variant="subtitle3">{item.description}</Typography>
                </div>
              </div>
            </Paper>
          </TimelineDotLine>
        ))}
    </>
  )
}

export default CheckComments
